// ============================================================================
// BIDC — central site configuration.
// ASSET SWAP: when the client zip "BIDC_Website_Assets" arrives, drop the files
// into /app/frontend/public/assets/ using the exact names below — every `local`
// path lights up automatically (AssetImage falls back to `fallback` until then).
// MAP: edit MAP.query / MAP.lat / MAP.lng here to retarget the embedded map.
// ============================================================================

const px = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const ASSETS = {
  logoGold: { local: "/assets/logo_gold.webp", fallback: null },
  logoWhite: { local: "/assets/logo_white.webp", fallback: null },
  badgeHaryana: { local: "/assets/badge_haryana.webp", fallback: null },
  badgeMsme: { local: "/assets/badge_msme.webp", fallback: null },
  sitePlan: { local: "/assets/siteplan_final.webp", fallback: px(16726161) },
  masterPlan: { local: "/assets/masterplan.webp", fallback: px(16726161) },
  mapGraphic: { local: "/assets/map.webp", fallback: null },
  hero: { local: "/assets/factory.webp", fallback: px(33461602, 1920) },
  sheds: { local: "/assets/sheds.webp", fallback: px(9305407) },
  bdc: { local: "/assets/bdc.webp", fallback: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80" },
  exhibition: { local: "/assets/exhibition.webp", fallback: "https://images.unsplash.com/photo-1758448500688-3ababa93fd67?auto=format&fit=crop&w=1200&q=80" },
  cfc: { local: "/assets/cfc.webp", fallback: null },
  labour: { local: "/assets/labour.webp", fallback: null },
  stp: { local: "/assets/stp.webp", fallback: null },
  office: { local: "/assets/office.webp", fallback: null },
  pipes: { local: "/assets/pipes.webp", fallback: null },
};

export const CONTACT = {
  phones: ["7056550679", "7090300000", "8168477090", "8506067000", "8168091205"],
  primaryPhone: "9817777265",
  whatsappPrimary: "919817777265",
  whatsappSecondary: "917020900600",
  email: "Tirupatidevelopersbhiwani@gmail.com",
  website: "www.tirupatideveloper.co.in",
  websiteUrl: "https://www.tirupatideveloper.co.in",
  address: "Site Office: Bhiwani–Loharu Road, NH-709, Bhiwani, Haryana",
};

export const waLink = (number, text) =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const MAP = {
  query: "Hetampur, Bhiwani, Haryana",
  lat: 28.694042,
  lng: 75.995093,
  embedUrl: () =>
    `https://www.google.com/maps?q=${MAP.lat},${MAP.lng}&z=14&output=embed`,
  directionsUrl: () =>
    `https://www.google.com/maps/dir/?api=1&destination=${MAP.lat},${MAP.lng}`,
};

export const RATE_PER_SQYD = 6500;

export const PRICE_TABLE = [
  { size: 550, label: "550 sq yd", price: "₹35.75 L" },
  { size: 750, label: "750 sq yd", price: "₹48.75 L" },
  { size: 1000, label: "1,000 sq yd", price: "₹65 L" },
  { size: 1500, label: "1,500 sq yd", price: "₹97.5 L" },
  { size: 1845, label: "1,845 sq yd", price: "₹1.20 Cr" },
];

export const HERO_BADGES = [
  { id: "govt", label: "Govt. Approved", sub: "Haryana MSME Cluster · Feb 2026" },
  { id: "prime", label: "Prime / Focus Area", sub: "Max incentives under MSME Policy 2026" },
  { id: "nh", label: "Bhiwani–Loharu Road", sub: "NH-709 frontage" },
];

export const GLANCE_STATS = [
  { value: 30.25, decimals: 2, suffix: "", label: "Acres · Phase 1" },
  { value: 77, suffix: "", label: "Industrial plots" },
  { value: 10, suffix: "", label: "Plug & play sheds (lease)" },
  { value: 40, prefix: "~", suffix: "%", label: "Already sold" },
];

export const PILLARS = [
  {
    title: "Land & Approvals",
    desc: "Clear titles, CLU, licences and cluster approval — already done. You buy ready, not promised.",
  },
  {
    title: "Infrastructure",
    desc: "Industrial-grade roads, power, water, CETP & STP — built before you build.",
  },
  {
    title: "Ecosystem",
    desc: "BDC, Exhibition Centre, Common Facility Centre and labour quarters inside the boundary.",
  },
  {
    title: "Hand-holding",
    desc: "DPR, subsidy filings and bank loans — our team walks with you till production starts.",
  },
];

export const HARYANA_STATS = [
  { value: 9.5, decimals: 1, suffix: "%", label: "GSDP growth 2025-26", note: "vs India 7.4%" },
  { value: 13.7, decimals: 1, prefix: "₹", suffix: " lakh Cr", label: "State economy", note: "among India's fastest" },
  { value: 28, suffix: "%", label: "Manufacturing share", note: "vs 17% national" },
  { value: 4.41, decimals: 2, prefix: "₹", suffix: " lakh", label: "Per-capita income", note: "1.75× India average" },
];

export const WHY_BHIWANI = [
  {
    title: "Supply exhausted",
    desc: "All 354 industrial plots in HUDA Sectors 21 & 26 stand allotted. Bhiwani's next address for industry is here.",
  },
  {
    title: "270 rubber & plastic units",
    desc: "A working industrial base already thrives in the district — suppliers, buyers and skilled hands in place.",
  },
  {
    title: "Business DNA",
    desc: "Guar gum exports, Bhiwani Textile Mills, TIT&S textile institute and a 200-year-old grain mandi.",
  },
  {
    title: "Rail junction",
    desc: "Bhiwani junction connects Rewari, Hisar and Rohtak–Delhi — freight and workforce move with ease.",
  },
];

export const DISTANCES = [
  { label: "NH-709 (Bhiwani–Loharu Road)", km: 1.5 },
  { label: "New Grain Market, Bhiwani", km: 16 },
  { label: "NH-152D", km: 30 },
  { label: "Hisar", km: 50 },
  { label: "Delhi / Gurugram", km: 100 },
];

export const FREIGHT_NOTE =
  "Rewari dry port — CONCOR Kathuwas MMLP on the Western Dedicated Freight Corridor — puts ports within scheduled reach.";

export const INFRASTRUCTURE = [
  { icon: "Route", title: "60.5 ft RCC roads", desc: "Wide concrete internal roads on a grid, built for trailers and containers." },
  { icon: "Zap", title: "24×7 industrial power", desc: "Independent industrial feeders — no domestic load sharing." },
  { icon: "Recycle", title: "CETP + STP", desc: "Separate industrial effluent and domestic sewage lines inside the boundary." },
  { icon: "Siren", title: "Fire station", desc: "On-site fire station with 5 lakh litre dedicated water storage." },
  { icon: "Droplets", title: "Dual water lines", desc: "Fresh and recycled water networks run side by side." },
  { icon: "CloudRain", title: "Rain water harvesting", desc: "Groundwater recharge built into the estate design." },
  { icon: "Video", title: "CCTV & gated campus", desc: "Single controlled entry, estate-wide surveillance." },
  { icon: "Trees", title: "Green campus", desc: "Tree-lined avenues soften a hard-working estate." },
  { icon: "Building2", title: "Labour quarters", desc: "Worker housing inside the campus — zero commute." },
];

export const ECOSYSTEM = [
  {
    key: "bdc",
    icon: "Landmark",
    title: "Business Development Centre",
    desc: "Single window for approvals, subsidy filings and finance. Networking, mentoring and paperwork — under one roof.",
  },
  {
    key: "exhibition",
    icon: "Presentation",
    title: "Exhibition Centre",
    desc: "Year-round product showcase, buyer–seller meets and trade fairs — your market comes to you.",
  },
  {
    key: "cfc",
    icon: "Cog",
    title: "Common Facility Centre",
    desc: "Servo injection moulding machines — prototype, test and scale without buying heavy machinery.",
  },
  {
    key: "labour",
    icon: "Home",
    title: "Labour Quarters",
    desc: "0 km commute makes 3 shifts practical and keeps attrition low.",
  },
];

export const INDUSTRIES_WELCOME = [
  "Plastic products & moulding",
  "Pipes, wires & packaging",
  "Non-woven & technical textiles",
  "Engineering & metal",
  "Electrical goods",
  "Food processing",
  "Textiles & garments",
];

export const INDUSTRIES_SIGNED = [
  "Injection moulding",
  "Plastic furniture",
  "Pipe manufacturing",
  "Electrical wires",
  "Non-woven fabrics",
  "PP yarn",
  "Technical textiles",
  "Metal industries",
];

export const INCENTIVES_MAIN = [
  { value: "35%", label: "Capital investment subsidy", note: "up to ₹4 Cr" },
  { value: "100%", label: "Stamp duty refund", note: "on plot registration" },
  { value: "70%", label: "Net SGST reimbursement", note: "for 7 years" },
  { value: "7%", label: "Interest subsidy", note: "up to ₹25 lakh / year" },
];

export const INCENTIVES_MORE = [
  "Power subsidy ₹2/unit for 5 years",
  "Solar rooftop 30% assistance",
  "Automation 25% assistance",
  "R&D / lab setup 50% assistance",
  "Quality certification 50% support",
  "Export freight support",
  "Local employment ₹1.2 lakh / person",
  "Food processing capital subsidy up to 45%",
  "Textiles sector capital subsidy up to 40%",
];

export const INCENTIVE_EXAMPLE = {
  title: "Illustrative: a ₹2.3 Cr unit",
  rows: [
    { item: "Capital investment subsidy (35%)", amount: "≈ ₹80.5 L" },
    { item: "Stamp duty refund (100%)", amount: "≈ ₹8 L" },
    { item: "Net SGST reimbursement (7 yrs)", amount: "≈ ₹75 L" },
    { item: "Interest subsidy (7%, capped)", amount: "≈ ₹25 L" },
  ],
  total: "≈ ₹1.9 Cr back over 5 years",
  disclaimer: "Illustrative only. Actual benefits depend on eligibility, approvals and policy terms.",
};

export const COMPARISON_RAW = [
  { item: "½ acre agricultural land", low: 60, high: 60 },
  { item: "Land levelling", low: 5, high: 10 },
  { item: "Boundary wall", low: 7, high: 7 },
  { item: "Road access", low: 3, high: 4 },
  { item: "Electricity connection", low: 7, high: 10 },
  { item: "STP / ETP", low: 3, high: 4 },
  { item: "Labour quarters", low: 7, high: 10 },
  { item: "CCTV & security", low: 1, high: 1 },
  { item: "Fire safety", low: 3, high: 4 },
  { item: "NOCs & approvals", low: 5, high: 7 },
];

export const TIMELINE = [
  { date: "Mar 2026", title: "Soft launch & Govt. approval", desc: "Cluster approved by Govt. of Haryana. Booking opens." },
  { date: "Jan 2027", title: "Roads & boundary", desc: "60.5 ft RCC internal roads and campus boundary take shape." },
  { date: "Apr 2027", title: "Power, CETP & STP", desc: "Industrial feeders energised; effluent and sewage plants commissioned." },
  { date: "Oct 2027", title: "Infrastructure complete", desc: "Full estate ready — build, lease, produce." },
];

export const INVESTOR_POINTS = [
  { title: "Ground-floor entry", desc: "NCR industrial plots trade at ₹20,000–30,000 per sq yd. BIDC is the early chapter, not the epilogue." },
  { title: "Limited supply", desc: "77 plots and 10 sheds in Phase 1 — with HUDA sectors in Bhiwani fully allotted, scarcity is structural." },
  { title: "Leasing demand", desc: "Plug & play sheds and labour quarters create rental yield from operating businesses." },
  { title: "Value tracks infrastructure", desc: "Each milestone — roads, power, CETP — reprices the estate." },
];

export const TRUST_ITEMS = [
  { title: "Govt.-approved cluster", desc: "MSME cluster approved by Govt. of Haryana, February 2026." },
  { title: "Prime / Focus Area", desc: "Estate classification that unlocks the highest incentive slab." },
  { title: "Bank of Maharashtra tie-up", desc: "Allied bank for project loans — up to 90% financing." },
  { title: "Estate-level CLU", desc: "Change of land use handled by the developer, not left to you." },
  { title: "Completion-linked payments", desc: "5% booking, then payments only as infrastructure completes." },
  { title: "Documents at site office", desc: "Titles, approvals and layouts open for inspection on site." },
];

export const BOOKING_STEPS = [
  { title: "Visit site", desc: "Walk the land, see the approvals, meet the team." },
  { title: "Choose plot", desc: "Pick your size and frontage on the master plan." },
  { title: "Book with 5%", desc: "Block your plot with a small booking amount." },
  { title: "Agreement & loan", desc: "Paperwork and up to 90% bank loan, hand-held by us." },
  { title: "Build & claim", desc: "Construct immediately; our BDC team files your subsidies." },
];

export const FAQS = [
  {
    q: "When do I actually receive the subsidies?",
    a: "Subsidies under the Haryana Progressive MSME & Export Promotion Policy 2026 are disbursed after your unit is eligible and claims are approved. Our BDC team prepares and files the paperwork with you, and the completion-linked payment plan means you are never ahead of the estate's progress.",
  },
  {
    q: "Can I get a bank loan for the plot?",
    a: "Yes. Bank of Maharashtra is the allied bank for the project, with financing available up to 90% of the plot cost, subject to the bank's eligibility norms. Our team assists with documentation.",
  },
  {
    q: "When can I start construction?",
    a: "Right after booking. You do not wait for the entire estate to finish — construction on your plot can begin immediately after the booking formalities.",
  },
  {
    q: "Which industries are allowed?",
    a: "Every manufacturing unit is welcome — plastics and moulding, pipes, wires, packaging, non-woven and technical textiles, engineering and metal, electrical goods, food processing, garments and more. Packaging makers and transporters also have a natural opportunity serving the estate.",
  },
  {
    q: "Can I merge adjacent plots?",
    a: "Yes. Adjacent plots can be combined into a larger parcel, subject to the layout plan and approval. Tell our team your requirement during your site visit and we will mark suitable combinations on the master plan.",
  },
  {
    q: "Who maintains the estate after completion?",
    a: "Estate-level maintenance of common infrastructure — roads, CETP/STP, security, greenery — is managed centrally, so your plot never becomes your headache. Detailed maintenance terms are shared at the site office.",
  },
];

export const GALLERY = [
  { key: "sheds", label: "Plug & play sheds" },
  { key: "masterPlan", label: "Aerial view — master plan" },
  { key: "bdc", label: "Business Development Centre" },
  { key: "exhibition", label: "Exhibition Centre" },
  { key: "cfc", label: "Common Facility Centre" },
  { key: "labour", label: "Labour quarters" },
  { key: "stp", label: "CETP / STP plant" },
  { key: "office", label: "Site office" },
];

// ---------------------------------------------------------------------------
// Interactive site plan data — 2 × 500 sq yd, 31 × 500–1,000, 50 × 1,000–2,000,
// 10 plug & play sheds. Deterministic so server/client never disagree.
// ---------------------------------------------------------------------------
const seededRandom = (seed) => {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
};

export const PLOT_CATEGORIES = {
  A: { label: "Compact · ~500 sq yd", color: "#C8A974", text: "#112018" },
  B: { label: "500–1,000 sq yd", color: "#7A8B5A", text: "#112018" },
  C: { label: "1,000–2,000 sq yd", color: "#2A4D3A", text: "#F7F5F0" },
  S: { label: "Plug & play shed · lease", color: "#B0793F", text: "#F7F5F0" },
};

function buildPlots() {
  const rand = seededRandom(202602);
  const pick = (arr) => arr[Math.floor(rand() * arr.length)];
  const plots = [];
  let n = 0;
  for (let i = 0; i < 2; i++) plots.push({ id: `P-${++n}`, size: 500, cat: "A", kind: "plot" });
  for (let i = 0; i < 31; i++) plots.push({ id: `P-${++n}`, size: pick([550, 750, 1000]), cat: "B", kind: "plot" });
  for (let i = 0; i < 50; i++) plots.push({ id: `P-${++n}`, size: pick([1100, 1250, 1500, 1700, 1845]), cat: "C", kind: "plot" });
  for (let i = 0; i < 10; i++) plots.push({ id: `SH-${i + 1}`, size: null, cat: "S", kind: "shed" });
  plots.forEach((p) => {
    p.status = p.kind === "shed" ? "lease" : rand() < 0.4 ? "sold" : "available";
    if (p.size) p.price = p.size * RATE_PER_SQYD;
  });
  return plots;
}

export const PLOTS = buildPlots();

export const BLOG_CATEGORIES = [
  "General",
  "Construction update",
  "Policy & incentives",
  "Market notes",
];

export const BLOG_COVERS = [
  { label: "Aerial master plan", value: "/assets/masterplan.webp" },
  { label: "Factory", value: "/assets/factory.webp" },
  { label: "Plug & play sheds", value: "/assets/sheds.webp" },
  { label: "Business Development Centre", value: "/assets/bdc.webp" },
  { label: "Exhibition Centre", value: "/assets/exhibition.webp" },
  { label: "Common Facility Centre", value: "/assets/cfc.webp" },
  { label: "Labour quarters", value: "/assets/labour.webp" },
  { label: "CETP / STP plant", value: "/assets/stp.webp" },
  { label: "Site office", value: "/assets/office.webp" },
  { label: "Connectivity map", value: "/assets/map.webp" },
];

export const formatINR = (n) => {
  if (n >= 1e7) {
    const cr = n / 1e7;
    return `₹${cr % 1 === 0 ? cr : cr.toFixed(2)} Cr`;
  }
  if (n >= 1e5) {
    const l = n / 1e5;
    return `₹${l % 1 === 0 ? l : l.toFixed(2)} L`;
  }
  return `₹${n.toLocaleString("en-IN")}`;
};
